import { RequestParameters } from "maplibre-gl";

function isLocalUrl(url: string): boolean {
  return (
    url.startsWith(`${window.location.protocol}//${window.location.host}`) || url.startsWith("/")
  );
}

export function createMapLibreTransformFunction(authHeader: string, isBearerToken = true) {
  const headerValue = isBearerToken ? `Bearer ${authHeader}` : authHeader;

  return (url: string): RequestParameters => ({
    url,
    ...(isLocalUrl(url) && {
      headers: { Authorization: headerValue },
    }),
  });
}
